// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__285lY","largestCol":"styles_largestCol__1tRzq","smallestCol":"styles_smallestCol__2LDzd"};